import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Logo eklendiğinde yorum satırını kaldırın
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="navbar">
          <Link to="/" className="logo-container">
            <img src={logo} alt="PHG Danışmanlık Logo" className="logo" />
          </Link>

          <button className="mobile-menu-btn" onClick={toggleMenu}>
            {isMenuOpen ? '✕' : '☰'}
          </button>

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" className="nav-link">Ana Sayfa</Link></li>
            <li><Link to="/kurumsal" className="nav-link">Kurumsal</Link></li>
            <li><Link to="/hizmetlerimiz" className="nav-link">Hizmetlerimiz</Link></li>
            <li><Link to="/ulkeler" className="nav-link">Ülkeler</Link></li>
            <li><Link to="/iletisim" className="nav-link">İletişim</Link></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;

